import ObjectUtils from '../utils/ObjectUtils'

export default class Party {
  public static CON = new Party(
    'Conservative Party',
    'Conservative',
    'CON',
    'rgb(40, 71, 124)'
  )
  public static LIB = new Party(
    'Liberal Party',
    'Liberal',
    'LIB',
    'rgb(197, 51, 43)'
  )
  public static NDP = new Party(
    'New Democratic Party',
    'NDP',
    'NDP',
    'rgb(235, 157, 65)'
  )
  public static GRN = new Party(
    'Green Party',
    'Green',
    'GRN',
    'rgb(87, 153, 67)'
  )
  public static BLQ = new Party(
    'Bloc Québécois',
    'Bloc',
    'BLQ',
    'rgb(97, 151, 214)'
  )
  public static PPC = new Party(
    "People's Party of Canada",
    'PPC',
    'PPC',
    'rgb(64, 46, 119)'
  )
  public static OTH = new Party('Other', 'Other', 'OTH', 'rgb(150, 150, 150)')

  private static PARTY_ARR = [
    Party.LIB,
    Party.CON,
    Party.NDP,
    Party.GRN,
    Party.BLQ,
    Party.PPC,
    Party.OTH
  ]

  private static PARTY_MAP = ObjectUtils.arrayToMap(
    Party.PARTY_ARR,
    (p): string => p.key
  )

  public static allPartiesArray(): Party[] {
    return Party.PARTY_ARR
  }

  public static allPartiesMap(): { [key: string]: Party } {
    return Party.PARTY_MAP
  }

  public static allPartyKeys(): string[] {
    return Object.keys(Party.PARTY_MAP)
  }

  public static fromKey(key: string): Party {
    const party = Party.allPartiesMap()[key]
    if (!party) {
      throw new Error(`Party with key ${key} not found.`)
    }
    return party
  }

  protected _name: string
  protected _shortName: string
  protected _code: string
  protected _rgbColor: string

  public constructor(
    name: string,
    shortName: string,
    code: string,
    rgbColor: string
  ) {
    this._name = name
    this._shortName = shortName
    this._code = code
    this._rgbColor = rgbColor
  }

  public get key(): string {
    return this._code
  }

  public get name(): string {
    return this._name
  }

  public get shortName(): string {
    return this._shortName
  }

  public get code(): string {
    return this._code
  }

  public get rgbColor(): string {
    return this._rgbColor
  }
}
